import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACTS, waLink, telLink } from "../lib/contact";

export default function FloatingButtons() {
  return (
    <>
      {/* WhatsApp floating button - bottom right */}
      <a
        href={waLink(CONTACTS.phones[0].raw)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chamar no WhatsApp"
        className="fixed bottom-6 right-6 z-50 group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] ring-pulse"></span>
        <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] text-white rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.5)] hover:scale-110 active:scale-95 transition-transform">
          <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" strokeWidth={2.2} />
        </span>
        <span className="hidden sm:block absolute right-[110%] top-1/2 -translate-y-1/2 mr-2 whitespace-nowrap px-3 py-1.5 bg-black text-white text-xs font-bold uppercase tracking-wider rounded-sm border border-white/10 opacity-0 group-hover:opacity-100 transition">
          Chamar no WhatsApp
        </span>
      </a>

      {/* Call floating button - bottom left, mobile only (avoid colliding with emergent badge - position above) */}
      <a
        href={telLink(CONTACTS.phones[0].raw)}
        data-testid="floating-call-btn"
        aria-label="Ligar Agora"
        className="md:hidden fixed bottom-[76px] right-6 z-50"
      >
        <span className="flex items-center justify-center w-14 h-14 bg-[#f3bd0e] text-black rounded-full shadow-[0_8px_30px_rgba(243,189,14,0.5)] hover:scale-110 active:scale-95 transition-transform">
          <Phone className="w-6 h-6" strokeWidth={2.4} />
        </span>
      </a>
    </>
  );
}
